// const $ = require('jquery');
import './vendor/objectFitPolyfill.min.js';

import Swiper from 'swiper/dist/js/swiper.js';
import 'select2';
import URI from 'urijs';
import easyXDM from 'easyxdm';
import '@fancyapps/fancybox';


const gridBreakpoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200
};

import './app/nav';


$(function () {

	/**
	 * Enable select2
	 */
	$('.select2').each(function () {

		// Determine options
		const options = {
			minimumResultsForSearch: $(this).hasClass("no-search") ? Infinity : 8,
			theme: "flat"
		};

		// Add placeholder data
		const placeholderData = $(this).data('placeholder');
		if (placeholderData) {
			options.placeholder = function () {
				return placeholderData;
			};
		}

		const allowClear = $(this).data('allow-clear');
		if (allowClear) {
			options.allowClear = allowClear;
		}

		$(this).select2(options);

	});



	/**
	 * Smooth scroll anchor clicks
	 */
	$("a").each(function () {

		// Return if no hash was found
		const hash = this.hash;
		if (!hash) return;

		// Get href without hash
		const href = this.href.replace(this.hash, "");

		// Get current uri without hash
		const uri = window.location.href.split("#")[0];

		// Check if link leads to another page. Abort if.
		if (uri !== href) return;

		// Find target and add scroll behaviour
		const $target = $(hash);
		if ($target.length) {
			$(this).on("click", function (event) {
				event.preventDefault();

				$('html, body').animate({
					scrollTop: $target.offset().top - 160
				}, 600);
			});
		}
	});


	/**
	 * Open external links in new window
	 */
	$("a").filter('[href^="http"], [href^="https"], [href^="//"]')
		.not('[href*="' + window.location.host + '"]')
		.attr('rel', 'noopener noreferrer')
		.attr('target', '_blank')
		.addClass("external-link");


	/**
	 * Scrolls down below the element (self) on click
	 */
	$(".scroll-down-self").each(function () {

		$(this).css("cursor", "pointer");
		$(this).on("click", function (event) {
			event.preventDefault();

			let offset = 30;
			let dataOffset = $(this).data("scroll-down-offset");
			if (dataOffset !== undefined) {
				offset = parseFloat(dataOffset);
			}

			$("html, body").animate({
				scrollTop: $(this).position().top + $(this).outerHeight(true) - offset
			}, 400);

		});
	});


	/**
	 * Block media-text image helper
	 */
	$(".block-media-text").each(function () {

		const $imageContainer = $(this).find(".block-media-text-image-container");
		const $imageObj = $(this).find(".block-media-text-image");
		// const $contentContainer = $(this).find(".block-media-text-content-container");

		// // Handle mobile version image-text swap
		// if ($(this).hasClass("block-media-text-image-below")) {
		// 	const $contentContainerClone = $contentContainer.clone();
		// 	$contentContainerClone.addClass("block-media-text-content-container-mobile");
		// 	$imageContainer.after($contentContainerClone);
		// }


		const $placer = $("<div class='block-media-text-image-placer'>");
		$placer.css("background-image", "url('" + $imageObj.prop("src") + "')");

		$imageObj.replaceWith($placer);

		function onResize() {
			if ($imageContainer.css("max-width") === 'none') {
				// Do not resize on smaller screens.
				$placer.width('100%');
			} else {
				// Fill the space to the right window side
				const width = $(window).width() - $placer.offset().left;
				$placer.width(width);
			}
		}

		// Init and on resize
		onResize();
		$(window).on('resize', function () {
			onResize();
		});

	});


	/**
	 * Block media-text-bg helper
	 */

	$(".block-media-text-bg").each(function () {


		if ($(this).hasClass("block-media-text-bg-restricted")) return;

		const maxWidth = 1.5;

		// Init
		const $imageContainer = $(this).find(".block-media-text-bg-image-container");
		const $imageObj = $(this).find(".block-media-text-bg-image");
		const mediaPositionRight = $(this).hasClass("block-media-text-bg-media-right");

		// Wrap placer div for faster calculation
		const $placer = $("<div class='block-media-text-image-placer'>");
		$placer.append($imageObj);
		$imageContainer.append($placer);


		function onResize() {
			if ($imageContainer.css("max-width") === 'none') {
				// Do not resize on smaller screens.
				$imageObj.width('100%');
				$imageObj.css("margin-left", 0)
			} else {


				if (mediaPositionRight) {

					// Fill the space to the right window side
					const maxWidthPx = maxWidth * $placer.width();
					const size = Math.min($(window).width() - $placer.offset().left, maxWidthPx);
					$imageObj.width(size);

				} else {

					// Fill the space to the left window side
					const maxWidthPx = (maxWidth - 1) * $placer.width();
					const offset = Math.min($placer.offset().left, maxWidthPx);
					$imageObj.width($placer.width() + offset);
					$imageObj.css("margin-left", -offset)
				}
			}
		}

		// Init and on resize
		onResize();
		$(window).on('resize', function () {
			onResize();
		});
	});


	/**
	 * Block block-media-text-card helper
	 */
	$(".block-media-text-card").each(function () {

		// Init
		const $contentContainerBg = $(this).find(".block-media-text-card-content-container-bg");

		function onResize() {
			// Fill the space to the right window side
			const width = $(window).width() - $contentContainerBg.offset().left;
			$contentContainerBg.width(width);
		}

		// Init and on resize
		onResize();
		$(window).on('resize', function () {
			onResize();
		});
	});


	/**
	 * Block block-hero helper
	 */
	$(".block-hero").each(function () {

		// Init
		const $hero = $(this);
		const $contentPosition = $(this).find(".block-hero-content-position");
		const $scroller = $(this).find(".block-hero-scroller");

		const posX = $contentPosition.data("pos-x");
		const posY = $contentPosition.data("pos-y");


		function onResize() {
			if ($contentPosition.css("position") === 'relative') {
				$contentPosition.css({
					left: "0",
					top: "0",
				});

			} else {
				$contentPosition.css({
					left: posX + "%",
					top: posY + "%",
				});
			}
		}

		function handleScroller() {
			// Pin the scroller to the bottom of the hero or to the bottom of the window
			const bottomSpace = $(window).height() - $hero[0].getBoundingClientRect().bottom;
			if (bottomSpace > 0) {
				$scroller.css("position", "absolute");
			} else {
				$scroller.css("position", "fixed");
			}
		}


		// Init and on resize
		onResize();
		handleScroller();
		$(window).on('resize', function () {
			onResize();
			handleScroller();
		});
		$(window).on('scroll', function () {
			handleScroller();
		});


		// Add scroll down behaviour to scroller
		$scroller.css("cursor", "pointer");
		$scroller.on("click", function (event) {
			event.preventDefault();

			let offset = 60;
			$("html, body").animate({
				scrollTop: $hero.position().top + $hero.outerHeight(true) - offset
			}, 400);
		});

	});


	/**
	 * Block image slider
	 */
	$(".block-image-slider").each(function () {

		const $container = $(this).find('.block-image-slider-container');

		// Add buttons
		const $prev = $('<div class="block-image-slider-prev"></div>');
		const $next = $('<div class="block-image-slider-next"></div>');
		$container.append($prev);
		$container.append($next);


		new Swiper($container[0], {
			direction: "horizontal",
			loop: true,
			// autoplay: {
			// 	delay: 5000,
			// },
			speed: 600,
			autoHeight: true,
			spaceBetween: 16,
			wrapperClass: "block-image-slider-wrapper",
			slideClass: "block-image-slider-item",
			containerModifierClass: "block-image-slider-container-",
			navigation: {
				nextEl: $next[0],
				prevEl: $prev[0],
			},
		});
	});


	/**
	 * News list slider
	 */
	$(".dtg-slider").each(function () {


		const $container = $(this).find('.dtg-slider-container');

		const $prev = $(this).find('.dtg-slider-prev');
		const $next = $(this).find('.dtg-slider-next');
		const $pagination = $(this).find('.dtg-slider-pagination');


		new Swiper($container[0], {
			direction: "horizontal",
			loop: true,
			// autoplay: {
			// 	delay: 5000,
			// },
			speed: 600,
			slidesPerView: 3,
			spaceBetween: 32,
			autoHeight: true,
			wrapperClass: "dtg-slider-wrapper",
			slideClass: "dtg-slider-item",
			containerModifierClass: "dtg-slider-container-",
			navigation: {
				prevEl: $prev[0],
				nextEl: $next[0],
			},
			breakpoints: {
				[gridBreakpoints.lg]: {
					slidesPerView: 2,
				},
				[gridBreakpoints.sm]: {
					slidesPerView: 1,
				}
			},
			pagination: {
				el: $pagination[0],
				clickable: true,
			},

		});
	});


	/**
	 *  DTG list
	 */
	$(".dtg-list").each(function () {

		const $form = $(this).find(".dtg-list-form");
		const $listContainer = $(this).find(".dtg-list-container");
		const selfId = $(this).prop("id");

		const $inputs = $form.find("input");
		const $selects = $form.find("select");
		const $showMoreButtons = $(this).find(".dtg-show-more");

		let disableReload = false;
		let reloadDelay = false;
		let limit = $showMoreButtons.length > 0;
		const limitParam = "no_limit=1";
		const excludeFormOptions = $form.hasClass("dtg-list-form-exclude-options");

		// Autoload on change selection
		$selects.on("change", function (event) {
			if (!disableReload) {

				if (excludeFormOptions) {
					// Reset all other forms
					const $currentSelect = $(this);
					disableReload = true;

					$selects.each(function () {
						if (!$(this).is($currentSelect)) {
							$(this).val("").trigger("change");
						}
					});
					disableReload = false;
				}

				reloadData();
			}
		});

		$inputs.on("keyup", function (event) {
			if (!disableReload) {

				// Clear previous timeouts
				clearTimeout(reloadDelay);
				reloadDelay = setTimeout(function () {
					reloadData();
				}, 600);
			}
		});


		function initShowMoreButtons($where) {
			$where.find(".dtg-show-more").on("click", function (event) {
				event.preventDefault();
				limit = false;
				reloadData();
			});
		}

		initShowMoreButtons($(this));

		// Handle reset buttons
		$form.find(".dtg-list-button.reset").on("click", function (event) {
			event.preventDefault();

			disableReload = true;

			// Find data-reset
			const resetElement = $($(this).data("reset"));
			if (resetElement.length) {
				resetElement.val("").trigger("change");
			} else {
				$inputs.each(function () {
					$(this).val("");
				});
				$selects.each(function () {
					$(this).val("").trigger("change");
				});
				limit = true;
			}

			disableReload = false;

			reloadData();
		});


		function reloadData() {

			// Reset delay
			if (reloadDelay) {
				clearTimeout(reloadDelay);
			}

			let serializedForm = $form.find(":input")
				.filter(function (index, element) {
					const val = $(element).val();
					return (val !== '' && val !== '_any');
				}).serialize();

			if (!limit) {
				serializedForm += (serializedForm.length ? '&' : '?') + limitParam;
			}

			$.ajax({
				type: 'GET',
				url: $form.attr("action"),
				data: serializedForm,
				success: function (data) {

					// Rewrite current URI
					const uri = new URI();
					uri.query(serializedForm);
					window.history.replaceState(null, null, uri.toString());

					// Reload the content of the list
					const $newContainer = $(data).find("#" + selfId + " .dtg-list-container");
					$listContainer.fadeOut(250, function () {
						$listContainer.html($newContainer).fadeIn(250);

						initShowMoreButtons($listContainer);
					});

				}
			});
		}


	});

	/**
	 *  Jobfinder list
	 */
	$(".dtg-jobfinder-list").each(function () {

		let limit = 5;
		let activateLimit = true;

		const $form = $(this).find(".dtg-jobfinder-list-form");
		const $listContainer = $(this).find(".dtg-jobfinder-list-container");
		const $listItems = $listContainer.find(".dtg-jobfinder-list-item");

		const $selects = $form.find("select");
		const $inputs = $form.find("input");

		const $limiter = $(this).find(".dtg-jobfinder-list-limited");

		let disableReload = false;


		// Autoload on change selection
		$selects.on("change", function (event) {
			if (!disableReload) {
				activateLimit = false;
				reloadData();
			}
		});

		$inputs.on("keyup", function (event) {
			if (!disableReload) {
				activateLimit = false;
				reloadData();
			}
		});


		$form.find(".dtg-list-button.reset").on("click", function (event) {
			event.preventDefault();

			disableReload = true;

			// Find data-reset

			const resetElement = $($(this).data("reset"));
			if (resetElement.length) {
				resetElement.val("").trigger("change");
			} else {
				$inputs.each(function () {
					$(this).val("");
				});
				$selects.each(function () {
					$(this).val("").trigger("change");
				});
			}

			disableReload = false;

			if (!resetElement.length) {
				activateLimit = true;
			}
			reloadData();

		});


		// // Initially hide after limit
		// function limitItems() {
		// 	$listItems.each(function (index) {
		// 		if (index >= limit) {
		// 			$(this).hide();
		// 		}
		// 	});
		// 	// Show limiter
		// 	$limiter.show();
		// }
		//
		// limitItems();

		$limiter.show();

		$limiter.css("cursor", "pointer").on("click", function () {
			activateLimit = false;
			reloadData();
		});

		// Init
		reloadData();


		function reloadData() {

			// Serialize form
			const serializedFilters = $form.serializeArray();

			// const serializedFilters = $form.find(":input")
			// 	.filter(function (index, element) {
			// 		const val = $(element).val();
			// 		return (val !== '' && val !== '_any');
			// 	}).serialize();


			let countVisibleItems = 0;

			// activateLimit

			// Check each item individually
			$listItems.each(function () {

				const $item = $(this);
				let visible = true;

				serializedFilters.forEach(function (filter) {

					if (!filter.value || '_any' === filter.value) {
						return;
					}


					if ('search' === filter.name) {

						// Search every field

						const fields = ["city", "position", "experience", "company", "title"];

						for (let i = 0; i < fields.length; i++) {
							let key = fields[i];
							if ($item.data(key).toUpperCase().indexOf(filter.value.toUpperCase()) !== -1) {
								return;
							}
						}

						// None found.
						visible = false;

					} else {

						// Search
						const data = $item.data(filter.name).split(";");
						if (!data.includes(filter.value)) {
							// Not found
							visible = false;
						}
					}

				});

				// Set isLimited, if limit is active an object should be hidden
				const isLimited = activateLimit ? (limit <= countVisibleItems) : false;

				if (visible && !isLimited) {
					countVisibleItems++;
					$item.show();
				} else {
					$item.hide();
				}
			});

			// Show/hide clickable limit-reset object
			if (activateLimit && countVisibleItems >= limit) {
				$limiter.show();
			} else {
				$limiter.hide();
			}
		}

	});


	/**
	 * Handle reset button in forms
	 */
	$(".dtg-list-button.reset").on("click", function (event) {
		event.preventDefault();

		const resetElement = $($(this).data("reset"));
		if (resetElement.length) {
			resetElement.val("").focus();
		}
	});


	/**
	 * Ninja forms "required fields" helper
	 */
	window.setTimeout(function () {
		// $(document).on( 'nfFormReady', function( event, layoutView ) { }); // Did not work. Timeout hack used instead

		$(".nf-field-element").each(function () {
			const $input = $(this).find("input[required]");
			if ($input.length) {
				if ($(this).css("display") === "none") {
					$(this).parent().addClass("nxb-nf-required")
				} else {
					$(this).addClass("nxb-nf-required");
				}

				$(this).parent().find(".ninja-forms-req-symbol").hide();
			}
		});

	}, 1000);


	/**
	 * iFrame helper (for HR4You)
	 */
	$("iframe").each(function () {
		const $iframe = $(this);

		const remoteSrc = $(this).data("remote");
		if (!remoteSrc) return;

		const offset = parseInt($(this).data("offset"));

		new easyXDM.Socket({
			remote: remoteSrc,
			onMessage: function (message, origin) {
				const height = parseInt(message) + offset;
				$iframe.height(height + "px");
			}
		});
	});


	/**
	 * To top button
	 */
	$(".dtg-scroll-to-top").each(function () {

		const $element = $(this);

		$(this).on("click", function (event) {
			event.preventDefault();

			$("html, body").animate({
				scrollTop: 0
			}, 600);

		});

		$(window).on('scroll', function () {
			const top = $(document).scrollTop();
			if (top > 1500) {
				$element.addClass("dtg-scroll-to-top-show");
			} else {
				$element.removeClass("dtg-scroll-to-top-show");
			}
		});
	});


	/**
	 * Bullet point block helper
	 */
	$(".block-bullet-points").each(function () {
		$(this).find(".block-bullet-point").each(function () {

			const link = $(this).data("link");

			if (link) {
				$(this).css("cursor", "pointer");
				$(this).on("click", function () {
					window.location = link;
				})
			}

		});
	});


	/**
	 * Fancybox
	 *
	 * Use with class "lightbox lightbox-group-2"
	 */
	$(".lightbox").each(function () {

		// Find group with class i.e. "lightbox-group-2"
		let group = 0;
		for (let i = 1; i <= 10; i++) {
			if ($(this).hasClass("lightbox-group-" + i)) {
				group = i;
			}
		}

		$(this).find("img").each(function () {

			// Get image source
			const source = $(this).prop("src");

			// Wrap link element
			const $linkWrapper = $("<a data-fancybox>");
			if (group) {
				$linkWrapper.attr("data-fancybox", "group-" + group);
			}
			$linkWrapper.prop("href", source);
			$(this).wrap($linkWrapper);
			$linkWrapper.fancybox({
				buttons: [
					"zoom",
					// "slideShow",
					// "thumbs",
					"close"
				],

			});

		});

	});


	/**
	 * Youtube remove "related videos".
	 *
	 * Since 2018 it is only possible to remove related videos from other channels. Videos from the own channel will always be related.
	 */
	$("iframe").each(function () {

		const src = $(this).prop("src");
		const uri = URI(src);

		// Search for youtube. Return if it is another source.
		if(-1 === uri.hostname().search("youtube")) {
			return
		}

		// Add rel=0 to query
		uri.addSearch("rel", 0);
		$(this).prop("src", uri.toString());
	});

});



